<template>
  <div>
    <b-row>
      <b-col
        v-if="loading"
        cols="12"
      >
        <loading-card />
      </b-col>
      <template v-else>
        <b-col cols="12">
          <default-card
            title="Genel Toplam"
            sub-title="Ay / Yıl"
            :value="complaints.grandTotals.mtd"
            :totals="complaints.grandTotals.ytd"
            icon="InfoIcon"
            color="info"
          />
        </b-col>
        <b-col
          v-for="item in complaints.data"
          :key="item.id"
          cols="12"
          md="4"
        >
          <default-card
            :title="item.title"
            sub-title="Ay / Yıl"
            :value="item.mtd"
            :totals="item.ytd"
            icon="InfoIcon"
            color="info"
          />
        </b-col>
      </template>
    </b-row>
  </div>
</template>
<script>
import { BRow, BCol } from 'bootstrap-vue'
import DefaultCard from '@/layouts/components/ReportCards/DefaultCard.vue'
import LoadingCard from '@/layouts/components/Loading.vue'

export default {
  name: 'SecondHands',
  components: {
    LoadingCard,
    BRow,
    BCol,
    DefaultCard,
  },
  computed: {
    loading() {
      return this.$store.getters['crmComplaintsReports/loading']
    },
    complaints() {
      return this.$store.getters['crmComplaintsReports/complaints']
    },
    complaintParams() {
      return this.$store.getters['crmComplaintsReports/complaintParams']
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.complaintParams.type = 'secondHands'
      this.$store.dispatch('crmComplaintsReports/getData', this.complaintParams)
    },
  },
}
</script>
